import { Directive, HostListener } from "@angular/core";

@Directive({
	selector: "[preventDefault]",
	standalone: false
})
export class PreventDefaultDirective {
	@HostListener("click", ["$event"])
	onClick($event: Event): void {
		if (!$event) {
			return;
		}
		$event.preventDefault();
		$event.stopPropagation();
	}
}
